import ts from 'typescript';

import libDomString from '../../../assets/typescript/lib/lib.dom.d.ts.txt?raw';
import libEs5String from '../../../assets/typescript/lib/lib.es5.d.ts.txt?raw';
import libDecoratorsString from '../../../assets/typescript/lib/lib.decorators.d.ts.txt?raw';
import libDecoratorsLegacyString from '../../../assets/typescript/lib/lib.decorators.legacy.d.ts.txt?raw';

import libEs2015String from '../../../assets/typescript/lib/lib.es2015.d.ts.txt?raw';
import libEs2015CoreString from '../../../assets/typescript/lib/lib.es2015.core.d.ts.txt?raw';
import libEs2015CollectionString from '../../../assets/typescript/lib/lib.es2015.collection.d.ts.txt?raw';
import libEs2015GeneratorString from '../../../assets/typescript/lib/lib.es2015.generator.d.ts.txt?raw';
import libEs2015PromiseString from '../../../assets/typescript/lib/lib.es2015.promise.d.ts.txt?raw';
import libEs2015IterableString from '../../../assets/typescript/lib/lib.es2015.iterable.d.ts.txt?raw';
import libEs2015ProxyString from '../../../assets/typescript/lib/lib.es2015.proxy.d.ts.txt?raw';
import libEs2015ReflectString from '../../../assets/typescript/lib/lib.es2015.reflect.d.ts.txt?raw';
import libEs2015SymbolString from '../../../assets/typescript/lib/lib.es2015.symbol.d.ts.txt?raw';
import libEs2015SymbolWellknownString from '../../../assets/typescript/lib/lib.es2015.symbol.wellknown.d.ts.txt?raw';
import libEs2016String from '../../../assets/typescript/lib/lib.es2016.d.ts.txt?raw';
import libEs2016ArrayIncludeString from '../../../assets/typescript/lib/lib.es2016.array.include.d.ts.txt?raw';
import libEs2016IntlString from '../../../assets/typescript/lib/lib.es2016.intl.d.ts.txt?raw';
import libEs2017ArraybufferString from '../../../assets/typescript/lib/lib.es2017.arraybuffer.d.ts.txt?raw';
import libEs2017String from '../../../assets/typescript/lib/lib.es2017.d.ts.txt?raw';
import libEs2017DateString from '../../../assets/typescript/lib/lib.es2017.date.d.ts.txt?raw';
import libEs2017ObjectString from '../../../assets/typescript/lib/lib.es2017.object.d.ts.txt?raw';
import libEs2017SharedmemoryString from '../../../assets/typescript/lib/lib.es2017.sharedmemory.d.ts.txt?raw';
import libEs2017StringString from '../../../assets/typescript/lib/lib.es2017.string.d.ts.txt?raw';
import libEs2017IntlString from '../../../assets/typescript/lib/lib.es2017.intl.d.ts.txt?raw';
import libEs2017TypedarraysString from '../../../assets/typescript/lib/lib.es2017.typedarrays.d.ts.txt?raw';
import libEs2018String from '../../../assets/typescript/lib/lib.es2018.d.ts.txt?raw';
import libEs2018AsynciterableString from '../../../assets/typescript/lib/lib.es2018.asynciterable.d.ts.txt?raw';
import libEs2018AsyncgeneratorString from '../../../assets/typescript/lib/lib.es2018.asyncgenerator.d.ts.txt?raw';
import libEs2018PromiseString from '../../../assets/typescript/lib/lib.es2018.promise.d.ts.txt?raw';
import libEs2018RegexpString from '../../../assets/typescript/lib/lib.es2018.regexp.d.ts.txt?raw';
import libEs2018IntlString from '../../../assets/typescript/lib/lib.es2018.intl.d.ts.txt?raw';
import libEs2019String from '../../../assets/typescript/lib/lib.es2019.d.ts.txt?raw';
import libEs2019ArrayString from '../../../assets/typescript/lib/lib.es2019.array.d.ts.txt?raw';
import libEs2019ObjectString from '../../../assets/typescript/lib/lib.es2019.object.d.ts.txt?raw';
import libEs2019StringString from '../../../assets/typescript/lib/lib.es2019.string.d.ts.txt?raw';
import libEs2019SymbolString from '../../../assets/typescript/lib/lib.es2019.symbol.d.ts.txt?raw';
import libEs2019IntlString from '../../../assets/typescript/lib/lib.es2019.intl.d.ts.txt?raw';
import libEs2020String from '../../../assets/typescript/lib/lib.es2020.d.ts.txt?raw';
import libEs2020BigintString from '../../../assets/typescript/lib/lib.es2020.bigint.d.ts.txt?raw';
import libEs2020DateString from '../../../assets/typescript/lib/lib.es2020.date.d.ts.txt?raw';
import libEs2020NumberString from '../../../assets/typescript/lib/lib.es2020.number.d.ts.txt?raw';
import libEs2020PromiseString from '../../../assets/typescript/lib/lib.es2020.promise.d.ts.txt?raw';
import libEs2020SharedmemoryString from '../../../assets/typescript/lib/lib.es2020.sharedmemory.d.ts.txt?raw';
import libEs2020StringString from '../../../assets/typescript/lib/lib.es2020.string.d.ts.txt?raw';
import libEs2020SymbolWellknownString from '../../../assets/typescript/lib/lib.es2020.symbol.wellknown.d.ts.txt?raw';
import libEs2020IntlString from '../../../assets/typescript/lib/lib.es2020.intl.d.ts.txt?raw';
import libEs2021String from '../../../assets/typescript/lib/lib.es2021.d.ts.txt?raw';
import libEs2021PromiseString from '../../../assets/typescript/lib/lib.es2021.promise.d.ts.txt?raw';
import libEs2021StringString from '../../../assets/typescript/lib/lib.es2021.string.d.ts.txt?raw';
import libEs2021WeakrefString from '../../../assets/typescript/lib/lib.es2021.weakref.d.ts.txt?raw';
import libEs2021IntlString from '../../../assets/typescript/lib/lib.es2021.intl.d.ts.txt?raw';
import libEs2022String from '../../../assets/typescript/lib/lib.es2022.d.ts.txt?raw';
import libEs2022ArrayString from '../../../assets/typescript/lib/lib.es2022.array.d.ts.txt?raw';
import libEs2022ErrorString from '../../../assets/typescript/lib/lib.es2022.error.d.ts.txt?raw';
import libEs2022IntlString from '../../../assets/typescript/lib/lib.es2022.intl.d.ts.txt?raw';
import libEs2022ObjectString from '../../../assets/typescript/lib/lib.es2022.object.d.ts.txt?raw';
import libEs2022StringString from '../../../assets/typescript/lib/lib.es2022.string.d.ts.txt?raw';
import libEs2022RegexpString from '../../../assets/typescript/lib/lib.es2022.regexp.d.ts.txt?raw';

export const typescriptVersion = ts.version;

export const compilerOptions: ts.CompilerOptions = {
  target: ts.ScriptTarget.ES2022,
  lib: ['lib.es2022.d.ts', 'lib.dom.d.ts'],
  // Additive + safe for existing flows/expressions (which use neither decorators nor imports):
  // experimentalDecorators lets custom Angular component bodies use @ViewChild/@HostListener;
  // esModuleInterop lets the editor's ambient `declare module '<lib>'` stubs resolve default/named imports.
  experimentalDecorators: true,
  esModuleInterop: true
};

export const defaultLibFileName = 'lib.es2022.d.ts'; // this is tied to the CompilerOptions.target

export const libs = {
  'lib.dom.d.ts': libDomString,
  'lib.es5.d.ts': libEs5String,
  'lib.decorators.d.ts': libDecoratorsString,
  'lib.decorators.legacy.d.ts': libDecoratorsLegacyString,
  'lib.es2015.d.ts': libEs2015String,
  'lib.es2015.core.d.ts': libEs2015CoreString,
  'lib.es2015.collection.d.ts': libEs2015CollectionString,
  'lib.es2015.generator.d.ts': libEs2015GeneratorString,
  'lib.es2015.promise.d.ts': libEs2015PromiseString,
  'lib.es2015.iterable.d.ts': libEs2015IterableString,
  'lib.es2015.proxy.d.ts': libEs2015ProxyString,
  'lib.es2015.reflect.d.ts': libEs2015ReflectString,
  'lib.es2015.symbol.d.ts': libEs2015SymbolString,
  'lib.es2015.symbol.wellknown.d.ts': libEs2015SymbolWellknownString,
  'lib.es2016.d.ts': libEs2016String,
  'lib.es2016.array.include.d.ts': libEs2016ArrayIncludeString,
  'lib.es2016.intl.d.ts': libEs2016IntlString,
  'lib.es2017.arraybuffer.d.ts': libEs2017ArraybufferString,
  'lib.es2017.d.ts': libEs2017String,
  'lib.es2017.date.d.ts': libEs2017DateString,
  'lib.es2017.object.d.ts': libEs2017ObjectString,
  'lib.es2017.sharedmemory.d.ts': libEs2017SharedmemoryString,
  'lib.es2017.string.d.ts': libEs2017StringString,
  'lib.es2017.intl.d.ts': libEs2017IntlString,
  'lib.es2017.typedarrays.d.ts': libEs2017TypedarraysString,
  'lib.es2018.d.ts': libEs2018String,
  'lib.es2018.asynciterable.d.ts': libEs2018AsynciterableString,
  'lib.es2018.asyncgenerator.d.ts': libEs2018AsyncgeneratorString,
  'lib.es2018.promise.d.ts': libEs2018PromiseString,
  'lib.es2018.regexp.d.ts': libEs2018RegexpString,
  'lib.es2018.intl.d.ts': libEs2018IntlString,
  'lib.es2019.d.ts': libEs2019String,
  'lib.es2019.array.d.ts': libEs2019ArrayString,
  'lib.es2019.object.d.ts': libEs2019ObjectString,
  'lib.es2019.string.d.ts': libEs2019StringString,
  'lib.es2019.symbol.d.ts': libEs2019SymbolString,
  'lib.es2019.intl.d.ts': libEs2019IntlString,
  'lib.es2020.d.ts': libEs2020String,
  'lib.es2020.bigint.d.ts': libEs2020BigintString,
  'lib.es2020.date.d.ts': libEs2020DateString,
  'lib.es2020.number.d.ts': libEs2020NumberString,
  'lib.es2020.promise.d.ts': libEs2020PromiseString,
  'lib.es2020.sharedmemory.d.ts': libEs2020SharedmemoryString,
  'lib.es2020.string.d.ts': libEs2020StringString,
  'lib.es2020.symbol.wellknown.d.ts': libEs2020SymbolWellknownString,
  'lib.es2020.intl.d.ts': libEs2020IntlString,
  'lib.es2021.d.ts': libEs2021String,
  'lib.es2021.promise.d.ts': libEs2021PromiseString,
  'lib.es2021.string.d.ts': libEs2021StringString,
  'lib.es2021.weakref.d.ts': libEs2021WeakrefString,
  'lib.es2021.intl.d.ts': libEs2021IntlString,
  'lib.es2022.d.ts': libEs2022String,
  'lib.es2022.array.d.ts': libEs2022ArrayString,
  'lib.es2022.error.d.ts': libEs2022ErrorString,
  'lib.es2022.intl.d.ts': libEs2022IntlString,
  'lib.es2022.object.d.ts': libEs2022ObjectString,
  'lib.es2022.string.d.ts': libEs2022StringString,
  'lib.es2022.regexp.d.ts': libEs2022RegexpString
};

export const libsSourceFiles: { [key: string]: ts.SourceFile } = {
};

Object.keys(libs).forEach(key => {
  libsSourceFiles[key] = ts.createSourceFile(key, libs[key], compilerOptions.target);
});

// see https://github.com/Microsoft/../../../assets/typescript/blob/master/src/compiler/diagnosticMessages.json for error messages
export const funcBodyDiagnosticCodesToIgnore = [1108, 1375, 1378];

// NOTES:

// The current setup relies on the fact that all the types are global
// because we don't want 'import' statements in flows and expressions
// If our types/typings have the need to import something, we should
// by convention import them somewhere and re-expose them as global types
// this is an example/way of redeclaring types in the global:
// export const globalTypings = `
// import moment from 'moment';
// import { HttpClient } from '@angular/common/http';

// declare global {
//   type IMoment = typeof moment;
//   type IHttpClient = HttpClient;
// }`;

// all of the following typings (libs) and standard libs should be available at
// where we are doing the validation of expressions and flows in the back-end

// we decided to not expose directly third-party libs types, instead
// we will introduce a facade where needed, leaving this just as an example
// export const momentTypings = require('moment/moment.d.ts.txt?raw').default;

// const customLibs = {
//   '/moment.d.ts': momentTypings,
// };
